import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6633">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6634">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6635">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6636">
            <ArrowLeft className="w-4 h-4" data-id="element-6637" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6638">NOIZA</div>
          <div className="w-20" data-id="element-6639" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6640">
        <div className="mb-12" data-id="element-6641">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6642">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6643" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6644">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6645">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6646">
          <section data-id="element-6647">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6648">
              <span className="text-[#006847]" data-id="element-6649">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6650">
              <p data-id="element-6651">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6652">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6653">
                <li data-id="element-6654">Haber leído íntegramente este documento</li>
                <li data-id="element-6655">Comprender su contenido en su totalidad</li>
                <li data-id="element-6656">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6657">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6658">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6659">
              <span className="text-[#006847]" data-id="element-6660">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6661">
              <p data-id="element-6662">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6663">
                <li data-id="element-6664">Software como servicio (SaaS)</li>
                <li data-id="element-6665">Marketplace digital gastronómico</li>
                <li data-id="element-6666">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6667">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6668">
                <li data-id="element-6669">Mostrar su menú digital</li>
                <li data-id="element-6670">Recibir pedidos de clientes</li>
                <li data-id="element-6671">Gestionar su operación interna</li>
                <li data-id="element-6672">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6673">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6674">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6675">
              <span className="text-[#006847]" data-id="element-6676">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6677">
              <p data-id="element-6678">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6679">
                <li data-id="element-6680">No es proveedor de alimentos</li>
                <li data-id="element-6681">No participa en la preparación de productos</li>
                <li data-id="element-6682">No manipula alimentos en ningún momento</li>
                <li data-id="element-6683">No realiza entregas ni logística</li>
                <li data-id="element-6684">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6685">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6686">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6687">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6688">
              <span className="text-[#006847]" data-id="element-6689">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6690">
              <p data-id="element-6691">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6692">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6693">
                <li data-id="element-6694">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6695">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6696">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6697">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6698">
                <li data-id="element-6699">Precios</li>
                <li data-id="element-6700">Menú</li>
                <li data-id="element-6701">Horarios</li>
                <li data-id="element-6702">Métodos de pago</li>
                <li data-id="element-6703">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6704">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6705">
              <span className="text-[#006847]" data-id="element-6706">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6707">
              <div data-id="element-6708">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6709">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6710">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6711">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6712">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6713">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6714">
                  <li data-id="element-6715">Calidad de los alimentos</li>
                  <li data-id="element-6716">Estado, frescura o preparación</li>
                  <li data-id="element-6717">Ingredientes utilizados</li>
                  <li data-id="element-6718">Contaminación cruzada</li>
                  <li data-id="element-6719">Problemas de higiene o salubridad</li>
                  <li data-id="element-6720">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6721">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6722">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6723">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6724">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6725">
                  <li data-id="element-6726">Retrasos en la entrega</li>
                  <li data-id="element-6727">Pérdida de pedidos</li>
                  <li data-id="element-6728">Entregas incompletas</li>
                  <li data-id="element-6729">Errores en dirección</li>
                  <li data-id="element-6730">Conducta de repartidores</li>
                  <li data-id="element-6731">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6732">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6733">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6734">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6735">
                  <li data-id="element-6736">Recepción de pagos</li>
                  <li data-id="element-6737">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6738">Manejo de efectivo</li>
                  <li data-id="element-6739">Confirmación de pagos</li>
                  <li data-id="element-6740">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6741">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6742">
                  <li data-id="element-6743">Pagos no recibidos</li>
                  <li data-id="element-6744">Comprobantes falsos</li>
                  <li data-id="element-6745">Errores en montos</li>
                  <li data-id="element-6746">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6747">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6748">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6749">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6750">
                  <li data-id="element-6751">Reclamos de clientes</li>
                  <li data-id="element-6752">Reembolsos</li>
                  <li data-id="element-6753">Cancelaciones</li>
                  <li data-id="element-6754">Disputas</li>
                  <li data-id="element-6755">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6756">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6757">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6758">
              <span className="text-[#006847]" data-id="element-6759">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6760">
              <p data-id="element-6761">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6762">
                <li data-id="element-6763">Responsable</li>
                <li data-id="element-6764">Legal</li>
                <li data-id="element-6765">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6766">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6767">
                <li data-id="element-6768">Publicar información falsa</li>
                <li data-id="element-6769">Manipular precios de forma engañosa</li>
                <li data-id="element-6770">Simular disponibilidad inexistente</li>
                <li data-id="element-6771">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6772">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6773">
              <span className="text-[#006847]" data-id="element-6774">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6775">
              <p data-id="element-6776">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6777">
                <li data-id="element-6778">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6779">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6780">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6781">
                <li data-id="element-6782">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6783">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6784">
                    <li data-id="element-6785">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6786">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6787">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6788">
              <span className="text-[#006847]" data-id="element-6789">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6790">
              <p data-id="element-6791">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6792">
                <li data-id="element-6793">Menú digital</li>
                <li data-id="element-6794">Gestión de pedidos</li>
                <li data-id="element-6795">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6796">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6797">
                  <p className="font-medium text-white mb-2" data-id="element-6798">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6799">
                    <li data-id="element-6800">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6801">
                  <p className="font-medium text-white mb-2" data-id="element-6802">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6803">
                    <li data-id="element-6804">Propiedad del software</li>
                    <li data-id="element-6805">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6806">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6807">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6808">
              <span className="text-[#006847]" data-id="element-6809">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6810">
              <p data-id="element-6811">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6812">
                <li data-id="element-6813">Disponibilidad continua</li>
                <li data-id="element-6814">Funcionamiento sin interrupciones</li>
                <li data-id="element-6815">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6816">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6817">
                <li data-id="element-6818">Fallas técnicas</li>
                <li data-id="element-6819">Actualizaciones</li>
                <li data-id="element-6820">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6821">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6822">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6823">
              <span className="text-[#006847]" data-id="element-6824">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6825">
              <p data-id="element-6826">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6827">
                <li data-id="element-6828">No está garantizada permanentemente</li>
                <li data-id="element-6829">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6830">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6831">
                <li data-id="element-6832">Destacar o no restaurantes</li>
                <li data-id="element-6833">Modificar posiciones</li>
                <li data-id="element-6834">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6835">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6836">
              <span className="text-[#006847]" data-id="element-6837">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6838">
              <p data-id="element-6839">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6840">
                <li data-id="element-6841">Cumplir con los pagos acordados</li>
                <li data-id="element-6842">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6843">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6844">
                <li data-id="element-6845">Suspender el servicio</li>
                <li data-id="element-6846">Limitar funcionalidades</li>
                <li data-id="element-6847">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6848">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6849">
              <span className="text-[#006847]" data-id="element-6850">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6851">
              <p data-id="element-6852">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6853">
                <li data-id="element-6854">Incumplimiento de términos</li>
                <li data-id="element-6855">Uso indebido</li>
                <li data-id="element-6856">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6857">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6858">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6859">
              <span className="text-[#006847]" data-id="element-6860">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6861">
              <p data-id="element-6862">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6863">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6864">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6865">
              <span className="text-[#006847]" data-id="element-6866">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6867">
              <p data-id="element-6868">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6869">
                <li data-id="element-6870">Pérdidas económicas</li>
                <li data-id="element-6871">Daños indirectos</li>
                <li data-id="element-6872">Lucro cesante</li>
                <li data-id="element-6873">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6874">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6875">
              <span className="text-[#006847]" data-id="element-6876">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6877">
              <p data-id="element-6878">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6879">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6880">
              <span className="text-[#006847]" data-id="element-6881">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6882">
              <p className="font-medium" data-id="element-6883">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6884">
                <li data-id="element-6885">Ha leído este documento completo</li>
                <li data-id="element-6886">Comprende su alcance</li>
                <li data-id="element-6887">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}